<template>
  <div class="wrapper">
    <div class="caption">{{caption}}</div>
    <div class="filter">
      <a-input ref="filter" clearable v-if="filterableOptions.length > 20" label="Filter" v-model="filter" />
    </div>
    <div class="options">
      <div :class="option.hide ? 'hidden' : ''" v-for="(option, index) in options" :key="index" @click="done(option)">{{option.label}}</div>
    </div>
    <a-btn-set>
      <a-btn @click="done">{{cancelText}}</a-btn>
    </a-btn-set>
  </div>
</template>

<script>

export default {
  props: {
    caption: {},
    cancelText: {
      type: String,
      default: 'Abbrechen'
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    filter: '',
    filterableOptions: []
  }),
  watch: {
    options: {
      immediate: true,
      handler (to) {
        this.filterableOptions = Array.from(to)
      }
    },
    filter: {
      immediate: true,
      handler (to) {
        this.filterableOptions.forEach(option => {
          option.hide = String(option.label).toLowerCase().indexOf(String(to).toLowerCase()) < 0
        })
      }
    }
  },
  methods: {
    done (option) {
      this.$emit('done', typeof option.value !== 'undefined' ? option.value : option.label)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.filter) {
        this.$refs.filter.labelAction()
      }
    })
  }
}

</script>

<style lang="scss" scoped>

.wrapper {
  .caption {
    margin-bottom: 20px;
    font-weight: bold;
    color: #014e9e;
  }

  .filter {
    margin-bottom: 20px;
  }

  .options {
    max-height: 30vh;
    @media (min-width: 800px) {
      max-height: 60vh;
    }
    overflow: auto;
    margin: 0 -20px;
    background-color: #eee;

    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 7px;
      background-color: rgba(0, 0, 0, .5);
      box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }

    div {
      cursor: pointer;
      font-size: 16px;
      padding: 10px 20px;
      background-color: #fff;
      margin: 1px 0;

      &:hover {
        background-color: transparent;
      }

      &.hidden {
        display: none;
      }
    }
  }
}

</style>
